
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useUuid } from 'JS/composables/uuid';

@Component({
	name: 'FulfillmentOption'
})
export default class FulfillmentOption extends Vue {

	@Prop({ type: Boolean })
	readonly disabled: boolean;

	@Prop({ type: String })
	readonly label: string;

	@Prop({ type: String })
	readonly mobileLabel: string;

	@Prop({ type: String })
	readonly secondaryLabel: string;

	@Prop({ type: Boolean })
	readonly loading: boolean;

	@Prop({ type: String })
	readonly promoText: string;

	@Prop({ type: Boolean, required: true })
	readonly selected: boolean;

	@Prop({ type: String, required: true })
	readonly fulfillmentOption: FulfillmentType;

	@Prop({ type: String, required: true })
	readonly listClass: string;

	@Prop({ type: String, required: true })
	readonly blainNumber: string;

	@Prop({ type: Boolean, required: false, default: false })
	readonly showRewardsOnlyMessagingForPromo: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	readonly showOrderByDisclaimer: boolean;

	@Prop({ type: String, required: false, default: "" })
	readonly orderByDate: string;

	@Prop({ type: String, required: false, default: "" })
	readonly arrivalDatePrefix: string;

	@Prop({ type: String, required: false, default: "" })
	readonly arrivalDate: string;


	get remainingSelectors() {
		return this.$store.getters.remainingSelectors;
	}

	contentId = useUuid();
	fulfillmentRadioId = useUuid();

	get isMobileDevice(): boolean {
		const { isMobile } = useBreakpoints();
		return isMobile.value;
	}

	get fulfillmentRadioName(): string {
		return `fulfillment-${this.blainNumber}`;
	}

	get mobileLabelToShow(): string {
		if (this.mobileLabel) { 
			return this.mobileLabel;
		}

		return this.label;
	}

	get hasRemainingSelectors(): boolean {
		return this.remainingSelectors?.length > 0;
	}

	get showSecondaryLabel(): boolean {
		return this.secondaryLabel && !this.hasRemainingSelectors;
	}

	changeOption() {
		if (this.selected || this.loading) return;
		this.$emit('change', this.fulfillmentOption);
	}
}
